import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Autocomplete,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNotification } from "../../hooks/useNotification";
import { fetchCouncilorList } from "../../api/councilorApi";
export default function AssignCouncilorModal({refetch, open, onClose,assignCouncilorToCall,info={} }) {
  const [selectedCouncilor, setSelectedCouncilor] = useState(null);
  const [councilorList, setCouncilorList] = useState([]);
  const [saving,setSaving] = useState(false)
  const  { showSuccessNotification, showErrorNotification } = useNotification()

  const handleAssign = () => {
    assignCouncilorToCall && info._id && assignCouncilorToCall({setSaving,payload:{_id:info._id,counselorId:selectedCouncilor?.value}})
    .then(res=>{
      onClose();
      refetch()
      showSuccessNotification("Assign counselor")
    }).catch(err=>{
      showErrorNotification(err?.message || "Failed to assign counselor")
    })
  };

  const fetchCounsilor = () => {
    fetchCouncilorList({ search: "" })
      .then(res => {
        setCouncilorList(res?.data || [])
      }).catch(error => {
        showErrorNotification(error?.message)
      })
  }

  useEffect(()=>{
    fetchCounsilor()
  },[])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "16px" },
      }}
    >
      {/* Title with Close Button */}
      <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#15243E" }}>
          Assign to Counselor
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Box mb={2}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
            {info?.leadId ? <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
              ID: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.leadId}</Typography>
            </Typography> :<Box></Box>}
           {info?.status && <Typography variant="span" sx={{ background: '#FFECA0', border: '1px solid #FFE187', textTransform: 'capitalize', color: '#FF6E20', fontSize: '12px', borderRadius: '20px', px: 2, }}>{info?.status}</Typography>}
          </Box>
          {info?.student && 
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Student: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.student}</Typography>
          </Typography> }
          {info?.universityName && <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Course: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.universityName}</Typography>
          </Typography>}
          
          {info?.preferredDate && <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 1 }}>
            Preferred: <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.preferredDate}</Typography> at <Typography variant="span" sx={{ fontWeight: "normal" }}>{info?.preferredTime}</Typography>
          </Typography>}
        </Box>

        {/* Searchable Dropdown */}
        <Box mb={2}>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb: 1 }}>
            Assign Counselor
          </Typography>
          <Autocomplete
            options={councilorList}
            getOptionLabel={(option) => option?.label}
            value={selectedCouncilor}
            onChange={(event, newValue) => setSelectedCouncilor(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search Counselor..."
                fullWidth
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": { height: 40, fontSize: "14px" },
                }}
              />
            )}
          />
        </Box>
      </DialogContent>

      {/* Footer Actions */}
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="outlined" sx={{ width: "100%", height: "50px" }}>
          Cancel
        </Button>
        <Button
          onClick={handleAssign}
          variant="contained"
          disabled={!selectedCouncilor || saving}
          loading={saving}
          sx={{ background: "#1075FF", width: "100%", height: "50px", "&:hover": { background: "#0d63d6" } }}
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
}
